import { Pipe, PipeTransform } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import {  } from 'rxjs/observable'

@Pipe({
    name: 'obtenerDireccion' // nombre del pipe en las directivas
})

export class ObtenerDireccionPipe implements PipeTransform {
    constructor(public http: Http) { }
    // Métdodo a implementar siempre
    transform(objetoCordenadas:any){
        console.log(objetoCordenadas)
        if(objetoCordenadas){
            let apiUrl ='https://maps.googleapis.com/maps/api/geocode/json?latlng=';
            let lat = objetoCordenadas.coordenadas.lat;
            let lng= objetoCordenadas.coordenadas.lng;
            let key = '&key=AIzaSyA0Fk92b6NyiMZVY7fAbOhW-2O1FsCOH2g';
            let urlCompleta=apiUrl + lat+','+lng + key;
            return this.http.get(urlCompleta)
                            .map((res:Response) => res.json())
        
        }
	}
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/obtener-direccion-por-coordenadas.pipe.ts